import React from 'react';
import { BsCheck2Circle } from 'react-icons/bs';

export const About = () => {
  const objectives = [
    "To encourage thrift among members so that each member may cultivate the habit of making savings at least once monthly, with a view to building up funds for their individual future use.",
    "To enable members to obtain loans from the society at a minimal interest rate with convenient terms of repayment.",
    "To promote mutual co-operation among members.",
    "To stock consumer and producer goods for distribution to members and non-members; (with priority to members) at fair and reasonable prices.",
    "To operate warehouses and cold room facilities for the storage of these consumer and producer goods and let out these facilities to interested parties.",
    "To acquire acres of land for sale, lease or Estate development to meet the housing needs of members or for residential, commercial or industrial purposes as a form of investment for the economic benefit of members and other interested parties.",
    "To undertake and invest in new ventures beneficial to its members and the Society as approved by the Management Committee. These include Projects Financing; Feasibility Studies, business plan etc.",
    "To undertake service businesses that will cater for the primary needs of members and other patrons managed in the overall interest of members and the Society.",
    "To undertake such financial management schemes like Special Withdraw-able Deposit and Community Banking Schemes at co-operative and competitive rates for members and other interested parties.",
    "To encourage fixed deposits from members out of which a fund may be established for giving short-term loans to members, to acquire stock of shares and other rewarding ventures.",
    "To raise funds through share holdings by members in the Society to undertake such other activities as are necessary for the attainment of these objects.",
    "To invest in Agricultural products. This will include crop and animal farming, buying and selling of Agricultural products and any other agricultural activity.",
    "To engage in other economic or social activity as may be approved by the Management Committee or the general meeting of members.",
    "To seek loans for residential, commercial or industrial housing development from banks, the co-operative circle and other financial institutions.",
    "To secure wholesale mortgage, either for on-lending to members or for housing development and let or sell such dwellings on mortgage basis.",
    "To do anything within the law and enter into any transaction which in the Society's opinion is necessary to ensure the proper performance of its functions or the attainment of the above listed objects."
  ];

  return (
    <section id="about">
      <div className="container mx-auto">
        <div className="row align-items-center">
          <div className="col-md-6">
            <div className="about-image-wrapper">
              <img src="img/about-us-new.png" className="img-fluid rounded shadow" alt="Lion Multi-Purpose Co-operative" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="about-content">
              <h2 className="about-heading">About Us</h2>
              <p className="about-description">
                Lion Multi-Purpose Co-operative Society Limited was incorporated on the 14th day of July, 2021 in
                Enugu State under the Nigeria Co-operative Societies Act No 98 of 2004. It is a voluntary association
                of individuals/legal persons united by common bond, who have come together to pursue their
                socio-economic goals for their own benefits with high regards to non-members.
              </p>

              <div className="objectives-container">
                <h3 className="objectives-heading">Our Objectives</h3>
                <div className="objectives-list">
                  {objectives.map((objective, index) => (
                    <div key={index} className="objective-item">
                      <BsCheck2Circle className="objective-icon" />
                      <span className="objective-text">{objective}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};